import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import './index.css';
import Dashboard from './features/embed/components/dashboard/Dashboard';
import { configuratorStore } from './store';

/**
 * Dashboard Entry Point
 *
 * This is the main entry point for the merchant customization dashboard.
 * The dashboard allows affiliate partners to:
 * 1. Enter their partner key
 * 2. Select products to include in their embed
 * 3. Filter available options (styles, colors, fonts, etc.)
 * 4. Preview the embed widget
 * 5. Copy the generated embed code (HTML and React formats)
 *
 *
 * Build this version with: VITE_BUILD_TARGET=dashboard yarn build
 */

const rootElement = document.getElementById('dashboard-root');
if (rootElement) {
  ReactDOM.createRoot(rootElement).render(
    <React.StrictMode>
      <Provider store={configuratorStore}>
        <Dashboard />
      </Provider>
    </React.StrictMode>
  );
} else {
  console.error(
    'Dashboard root element not found. Expected element with id="dashboard-root"'
  );
}
